import React from "react";
import NftHeading from "./NftComponents/NftHeading";
import NftImage from "./NftComponents/NftImage";
import NftPrice from "./NftComponents/NftPrice";
import NftOffers from "./NftComponents/NftOffers";
import NftDescription from "./NftComponents/NftDescription";
import NftActivity from "./NftComponents/NftActivity";
import NftMore from "./NftComponents/NftMore";
const Nft = () => {
    return (
        <>
            <div className="_nft_wrapper">
                <div className="_nft_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <NftImage />
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div className="_nft_content_wrap">
                                    <NftHeading />
                                    <NftPrice />
                                    <NftDescription />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <NftOffers />
            <NftActivity/>
            <NftMore/>
        </>
    )
}
export default Nft;